export type Orientation = 'portrait' | 'landscape';

export interface Size {
  width: string;
  height: string;
}

export class A4RatioHelper {
  private static readonly RATIO = 1.4142; // √2 ≈ 1.4142 => 841.89 / 595.276

  private static getRatioForOrientation(orientation: Orientation = 'portrait'): number {
    return orientation === 'portrait' ? this.RATIO : 1 / this.RATIO;
  }

  static getSizeInPixels(size: number, basedOn: 'width' | 'height', orientation: Orientation = 'portrait'): Size {
    const ratio: number = this.getRatioForOrientation(orientation);

    let width: number, height: number;

    if (basedOn === 'width') {
      width = size;
      height = Math.round(size * ratio);

      // Scale down if sizes exceed viewport:
      if (height > window.innerHeight) {
        const scale: number = window.innerHeight / height;
        width = Math.round(width * scale);
        height = window.innerHeight;
      }
      if (width > window.innerWidth) {
        const scale: number = window.innerWidth / width;
        width = window.innerWidth;
        height = Math.round(height * scale);
      }
    } else {
      height = size;
      width = Math.round(size / ratio);

      // Scale down if sizes exceed viewport:
      if (width > window.innerWidth) {
        const scale: number = window.innerWidth / width;
        height = Math.round(height * scale);
        width = window.innerWidth;
      }
      if (height > window.innerHeight) {
        const scale: number = window.innerHeight / height;
        width = Math.round(width * scale);
        height = window.innerHeight;
      }
    }

    return {
      width: `${width}px`,
      height: `${height}px`,
    };
  }

  static getSizeWithinViewport(size: number, basedOn: 'width' | 'height', orientation: Orientation = 'portrait'): Size {
    const ratio: number = this.getRatioForOrientation(orientation);

    let width: number, height: number;

    if (basedOn === 'width') {
      width = size;
      height = +(size * ratio);

      // Scale down if height exceeds 100vh:
      if (height > 100) {
        const scale: number = 100 / height;
        width *= scale;
        height = 100;
      }
    } else {
      height = size;
      width = +(size / ratio);

      // Scale down if width exceeds 100vw:
      if (width > 100) {
        const scale: number = 100 / width;
        height *= scale;
        width = 100;
      }
    }

    return {
      width: +width.toFixed(4) + 'vw',
      height: +height.toFixed(4) + 'vh',
    };
  }
}
